module.exports = __webpack_public_path__ + "static/img/R.fbe173e0.png";